import Marquee from "react-fast-marquee";
import { Smile } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";

const ROW_1 = [
  { img: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/no74cuzr_pexels-rdne-9034969.webp", alt: "Stagiaires satisfaits en salle de cours" },
  { img: "https://images.pexels.com/photos/20862827/pexels-photo-20862827.jpeg?auto=compress&cs=tinysrgb&w=900", alt: "Camion de transport de marchandises" },
  { img: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=900&q=80", alt: "Autocar de transport de voyageurs" },
  { img: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/iax7c3mj_pexels-mart-production-8472987.webp", alt: "Conseillère accompagnant un élève" },
];

const ROW_2 = [
  { img: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/wz36v1tt_pexels-ai25studioai-7144210.webp", alt: "Leçon de conduite avec un enseignant" },
  { img: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=900&q=80", alt: "Poids lourd sur la route" },
  { img: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/ocsam9fc_200c8b32d152.webp", alt: "Leçon de conduite poids lourd" },
  { img: "https://images.unsplash.com/photo-1772380043258-c768a6b09691?auto=format&fit=crop&w=900&q=80", alt: "Bus urbain" },
];

function Tile({ img, alt }) {
  return (
    <div className="group mx-3 h-56 w-80 shrink-0 overflow-hidden rounded-2xl sm:h-64 sm:w-96">
      <img
        src={img}
        alt={alt}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
    </div>
  );
}

export default function CampusGallery() {
  return (
    <section className="overflow-hidden bg-white py-24 lg:py-32" data-testid="campus-gallery">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <h2 className="font-display text-4xl font-black uppercase leading-[0.98] tracking-[-0.03em] text-brand-blue sm:text-5xl">
              Des centres modernes,<br />une communauté engagée
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="flex items-start gap-5 lg:pt-3">
              <span className="hidden h-14 w-14 shrink-0 items-center justify-center rounded-full bg-brand-red/10 text-brand-red sm:flex">
                <Smile className="h-7 w-7" />
              </span>
              <p className="text-lg leading-relaxed text-slate-600">
                L'expérience Educaser, c'est partout en Île-de-France ! Nos centres vous accueillent à
                Palaiseau, Noisy-le-Sec, Meaux, Choisy-le-Roi, Pontault-Combault, Roissy-en-France et
                Le Plessis-Belleville. Formations en présentiel, simulateurs haut de gamme et
                véhicules en double commande, pour une pédagogie de proximité et de qualité.
              </p>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Auto-scrolling gallery */}
      <div className="mt-14 space-y-5">
        <Marquee speed={40} gradient={false} pauseOnHover autoFill>
          {ROW_1.map((t, i) => <Tile key={i} {...t} />)}
        </Marquee>
        <Marquee speed={40} direction="right" gradient={false} pauseOnHover autoFill>
          {ROW_2.map((t, i) => <Tile key={i} {...t} />)}
        </Marquee>
      </div>
    </section>
  );
}
